export default "__VITE_ASSET__DOpTC75N__"